// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

// Your web app's devlopment Firebase configuration
// const firebaseConfig = {
//     apiKey: "AIzaSyBe7G3V5TGusJQj_whCAaZXpnW6FLMYHMc",
//     authDomain: "courtmate-dev-f8bcc.firebaseapp.com",
//     projectId: "courtmate-dev-f8bcc",
//     storageBucket: "courtmate-dev-f8bcc.firebasestorage.app",
//     messagingSenderId: "27323081699",
//     appId: "1:27323081699:web:70f14974e8bbcc41db36d6",
//     measurementId: "G-LPXH8H2Y0E"
// };

// For Prod
const firebaseConfig = {
  apiKey: "AIzaSyAk_aZ0e52-MUpfox33Nsz1BYZ9AZyKnPo",
  authDomain: "courtmate-b48f5.firebaseapp.com",
  projectId: "courtmate-b48f5",
  storageBucket: "courtmate-b48f5.appspot.com",
  messagingSenderId: "324614632724",
  appId: "1:324614632724:web:604b88f273d7fda386fe01",
  measurementId: "G-170HXP1JG6"
};



// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging and get a reference to the service
let messaging;
// Check if we're in a browser environment and if messaging is supported
if (typeof window !== 'undefined' && 'serviceWorker' in navigator && 'Notification' in window) {
    const checkIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (!checkIOSDevice) {
        try {
            messaging = getMessaging(app);
        } catch (error) {
            console.warn('Firebase Messaging initialization failed:', error);
            messaging = null;
        }
    }
}

const getDeviceFCM = async () => {
    if (!messaging) {
        console.warn('Firebase Messaging is not available');
        return null;
    }
    try {
        const token = await getToken(messaging, {
            vapidKey: "BPtJBqotUZCashAHtgiakgOLgDZ-qro0lTEcf59TO2iV8qJMbnkBo--cbiES_KDU_30jIZ92hPHO5HZ5M3Bv2DY",
            // vapidKey: "BM-PWkPmaJEonZLGN9NTBhKyQYzMVTZMAnGlQt0GuErw_t9wGNjrS6KGEkhVjbZbNmbVo_vtW0sA9IWQUSEcW50",
        });
        return token;
    } catch (error) {
        console.error('Error getting FCM token:', error);
        return null;
    }
}

export { app, messaging, getDeviceFCM };

